import { lazy, Suspense } from "react";
import { Amplify } from "aws-amplify";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { LoadingScreen } from "../components";

const Feedback = lazy(() => import('../pages/Feedback'));
const Home = lazy(() => import('../pages/Home'));
const Interviewee = lazy(() => import('../features/interviewee'));
const Interviewer = lazy(() => import('../features/interviewer'));
const Login = lazy(() => import('../pages/Login'));
const Welcome = lazy(() => import('../pages/Welcome'));
const JobRoles = lazy(() => import('../features/job-roles').then(m => ({ default: m.JobRoles })));
const JobRole = lazy(() => import('../features/job-roles').then(m => ({ default: m.JobRole })));
const RoleMigration = lazy(() => import('../features/job-roles').then(m => ({ default: m.RoleMigration })));
const OrganizationProfile = lazy(() => import('../features/organization').then(m => ({ default: m.OrganizationProfile })));
const AdminApp = lazy(() => import('./AdminRouter'));
const GreenRoom = lazy(() => import('../features/interviewee/GreenRoom'));

const region = import.meta.env.AWS_REGION || "us-east-1";
const apiKey   = import.meta.env.VITE_GRAPHQL_API_KEY;

Amplify.configure({
  Auth: {
    Cognito: {
      region,
      userPoolId:        import.meta.env.VITE_USER_POOL_ID,
      userPoolClientId:  import.meta.env.VITE_USER_POOL_CLIENT,
      identityPoolId:   import.meta.env.VITE_IDENTITY_POOL_ID,
    },
  },
  API: {
    GraphQL: {
      endpoint: import.meta.env.VITE_GRAPHQL_ENDPOINT,
      region,
      defaultAuthMode: 'apiKey',
      apiKey
    },
  },
});

export default function Router() {
  return (
    <>
      <BrowserRouter>
        <Suspense fallback={<LoadingScreen />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/reset" element={<Welcome reset />} />
            <Route path="/interviewer" element={<Interviewer isParticipant={false} />} />
            <Route path="/interviewee" element={<Interviewee />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/participant" element={<Interviewer isParticipant={true} />} />
            <Route path="/welcome" element={<Welcome />} />
            <Route path="/admin/*" element={<AdminApp />} />
            <Route path="/jobroles" element={<JobRoles />} />
            <Route path="/jobrole" element={<JobRole />} />
            <Route path="/rolemigration" element={<RoleMigration />} />
            <Route path="/organizationprofile" element={<OrganizationProfile />} />
            <Route path="/meeting" element={<GreenRoom />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}
